// extracted by mini-css-extract-plugin
export default {"summaryItem":"bFV8o"};